<div class="flex flex-row w-full flex-center items-center justify-between snackbar-message gap-2" *transloco="let t">
  <div [innerHTML]="data.message | safeHtml"></div>
  @if (data?.action) {
    <button mat-button class="custom-snackbar-btn" (click)="cancel()">
      {{ t('snackbar.action.' + data.action | lowercase) }}
    </button>
  }
</div>
